module.exports = __webpack_public_path__ + "static/media/Q.247b7958.jpg";